import React, { useState } from 'react';
import { View, Text, TextInput, TouchableOpacity } from 'react-native';
import { useRoute } from '@react-navigation/native';
import { getFirestore } from 'firebase/firestore';
import { useUser } from '../components/LoginPersistence';
import { BackgroundVideo } from '../components/BackgroundVideo';
import { CANVA_NAV_BLUE, CANVA_TITLE_CREAM, CANVA_TITLE_FONT, isValidNotifyEmail, notifyTitleForFeature } from '../utils/hamburgerMenu';
import { submitFeatureNotify } from '../utils/featureNotifyService';

export function NotifyWhenLive({ featureId: featureIdProp } = {}) {
  const route = useRoute();
  const { user } = useUser();
  const featureId = featureIdProp || route.params?.featureId || 'map';
  const featureTitle = notifyTitleForFeature(featureId);
  const [email, setEmail] = useState(user?.email || '');
  const [status, setStatus] = useState('');
  const [saving, setSaving] = useState(false);

  const onSubmit = async () => {
    if (saving) return;
    const clean = String(email || '').trim();
    if (!isValidNotifyEmail(clean)) {
      setStatus('Enter a valid email address.');
      return;
    }
    setSaving(true);
    setStatus('');
    try {
      await submitFeatureNotify(getFirestore(), {
        email: clean,
        feature: featureTitle,
        uid: user?.uid || null,
      });
      setStatus(`We’ll email you when ${featureTitle} is live.`);
    } catch (err) {
      setStatus(err?.message || 'Could not save that. Try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <View style={{ flex: 1 }}>
      <BackgroundVideo />
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', padding: 24 }}>
        <View
          style={{
            width: '100%',
            maxWidth: 520,
            backgroundColor: CANVA_NAV_BLUE,
            borderRadius: 20,
            paddingVertical: 36,
            paddingHorizontal: 28,
          }}
        >
          <Text
            style={{
              color: CANVA_TITLE_CREAM,
              fontFamily: CANVA_TITLE_FONT,
              fontSize: 28,
              textAlign: 'center',
              marginBottom: 8,
            }}
          >
            {featureTitle}
          </Text>
          <Text
            style={{
              color: '#ffffff',
              fontSize: 20,
              fontWeight: '700',
              textAlign: 'center',
              marginBottom: 10,
            }}
          >
            Notify me when this is live
          </Text>
          <Text style={{ color: 'rgba(255,255,255,0.85)', fontSize: 15, textAlign: 'center', lineHeight: 22, marginBottom: 22 }}>
            This page is not open yet. Leave your email and we’ll let you know when {featureTitle} is ready.
          </Text>
          <TextInput
            value={email}
            onChangeText={setEmail}
            placeholder="Email address"
            placeholderTextColor="rgba(255,255,255,0.45)"
            keyboardType="email-address"
            autoCapitalize="none"
            style={{
              borderWidth: 1,
              borderColor: 'rgba(255,255,255,0.28)',
              borderRadius: 10,
              paddingHorizontal: 14,
              paddingVertical: 12,
              color: '#ffffff',
              fontSize: 16,
              backgroundColor: 'rgba(0,0,0,0.18)',
              marginBottom: 14,
            }}
          />
          <TouchableOpacity
            onPress={onSubmit}
            disabled={saving}
            style={{
              backgroundColor: CANVA_TITLE_CREAM,
              borderRadius: 10,
              paddingVertical: 13,
              alignItems: 'center',
            }}
          >
              <Text style={{ color: '#111111', fontWeight: '800', fontSize: 16 }}>
              {saving ? 'Saving…' : 'Notify me'}
            </Text>
          </TouchableOpacity>
          {status ? (
            <Text style={{ color: '#ffffff', fontSize: 14, textAlign: 'center', marginTop: 14 }}>
              {status}
            </Text>
          ) : null}
        </View>
      </View>
    </View>
  );
}
